import { render, staticRenderFns } from "./CreatePriceNegotiation.vue?vue&type=template&id=597ed28c&"
import script from "./CreatePriceNegotiation.vue?vue&type=script&lang=js&"
export * from "./CreatePriceNegotiation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports